




















































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "train/getCoaches";

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "场馆",
      dataIndex: "stadium_name"
    },
    {
      title: "培训机构",
      dataIndex: "organization_name"
    },
    {
      title: "负责人",
      dataIndex: "contacts"
    },
    {
      title: "电话",
      dataIndex: "user_mobile"
    },
    {
      title: "现有学员",
      scopedSlots: { customRender: "student" }
    },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData();
  }
}
